export class DateModel {
    public date: Date;
    public day: number;
    public month: number;
    public year: number
    public isToday: boolean;
    public label: string;
    public isEnabled: boolean;
    public isSelected: boolean;
    public isInCurrentMonth: boolean;

    constructor(date: Date, enabled: boolean, selected: boolean, inCurrentMonth: boolean) {
        this.date = date;
        this.day = date.getDate();
        this.label = this.day.toString();
        this.month = date.getMonth();
        this.year = date.getFullYear();
        this.isEnabled = enabled;
        this.isSelected = selected;
        this.isInCurrentMonth = inCurrentMonth;

        const today = new Date();
        today.setHours(0,0,0,0);

        this.isToday = today.getTime() == date.getTime();
    }
}